import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setSelectedAsset, setSelectedDate, setSelectedSource } from '../../../../../features/manualExpenseSlice';
import { Box } from '@mui/material';
import FilterComponent from '../../../../ReusableFIlterComponent/FilterComponent';

export const ManualExpenseFilterItems = ({ clearSelectedManualExpense }: any) => {
  const { filteredManualExpense, selectedAsset, selectedSource, selectedDate, allTrafficSources } = useSelector((state: any) => state?.manualExpense);
  const dispatch = useDispatch();
  const [searchAsset, setSearchAsset] = useState("");
  const [searchSource, setSearchSource] = useState("");

  const filterConfig = [
    {
      key: "Related Asset",
      label: "Select an Asset ",
      searchTerm: searchAsset,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearchAsset(e.target.value),
      selectedOption: selectedAsset,
      filterName: "website_name",
      data: filteredManualExpense,
      onSelectionChange: (updatedSelection: any) => dispatch(setSelectedAsset(updatedSelection)),
      count: selectedAsset && selectedAsset.length,
      colorSelected: selectedAsset !== null && selectedAsset.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "source",
      label: "Select a Source",
      searchTerm: searchSource,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchSource(e.target.value),
      selectedOption: selectedSource,
      filterName: "traffic_source__shared_uid",
      data: filteredManualExpense,
      onSelectionChange: (updatedSelection: any) => dispatch(setSelectedSource(updatedSelection)),
      count: selectedSource && selectedSource.length,
      colorSelected:
        selectedSource !== null && selectedSource.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
      trafficSources: allTrafficSources,
    },
    {
      key: "date",
      label: "Date",
      selectedOption: selectedDate,
      filterName: "date",
      data: filteredManualExpense,
      onSelectionChange: (updatedSelection: any) => dispatch(setSelectedDate(updatedSelection)),
      count: 0,
      colorSelected:
        selectedDate !== null && selectedDate.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      isDateRangeFilter: true,
    },
  ];

  const clearFilters = () => {
    setSearchAsset("");
    setSearchSource("");
    clearSelectedManualExpense();
    dispatch(setSelectedAsset([]));
    dispatch(setSelectedSource([]));
    dispatch(setSelectedDate([]));
  }
  return (
    <>
      <Box>
        <FilterComponent filterConfig={filterConfig} clearFilters={clearFilters} />
      </Box>
    </>
  )
}

